import { render } from "./NumberWidgetLayout.vue?vue&type=template&id=dd1895e4"
import script from "./NumberWidgetLayout.vue?vue&type=script&lang=js"
export * from "./NumberWidgetLayout.vue?vue&type=script&lang=js"

import "./NumberWidgetLayout.vue?vue&type=style&index=0&id=dd1895e4&lang=scss"
script.render = render

export default script